export type OtpChallengeHeader = 'x-otp-code' | 'x-new-phone-otp-code';
export type OtpChallengeTarget = 'CURRENT_PHONE' | 'NEW_PHONE';

export type OtpChallenge = {
  code?: string;
  otpTarget?: OtpChallengeTarget;
  header?: OtpChallengeHeader;
  maskedPhone?: string;
  message?: string;
};

export type OtpHeaders = Partial<Record<OtpChallengeHeader, string>>;

export const OTP_HEADER_CURRENT_PHONE: OtpChallengeHeader = 'x-otp-code';
export const OTP_HEADER_NEW_PHONE: OtpChallengeHeader = 'x-new-phone-otp-code';

const OTP_CHALLENGE_HEADERS: OtpChallengeHeader[] = [
  OTP_HEADER_CURRENT_PHONE,
  OTP_HEADER_NEW_PHONE,
];

const mapBackendOtpType = (otp: unknown): Pick<OtpChallenge, 'header' | 'otpTarget'> => {
  if (otp === 'A') {
    return {
      header: OTP_HEADER_CURRENT_PHONE,
      otpTarget: 'CURRENT_PHONE',
    };
  }

  if (otp === 'B') {
    return {
      header: OTP_HEADER_NEW_PHONE,
      otpTarget: 'NEW_PHONE',
    };
  }

  return {};
};

export const isOtpChallengeHeader = (header: unknown): header is OtpChallengeHeader =>
  typeof header === 'string' &&
  OTP_CHALLENGE_HEADERS.includes(header as OtpChallengeHeader);

export const parseOtpChallenge = (payload: unknown): OtpChallenge | undefined => {
  if (!payload || typeof payload !== 'object') return undefined;

  const data = payload as Record<string, unknown>;
  const mappedOtpType = mapBackendOtpType(data.otp);
  const header = isOtpChallengeHeader(data.header) ? data.header : mappedOtpType.header;
  const code = typeof data.code === 'string' ? data.code : undefined;
  const otpTarget =
    data.otpTarget === 'CURRENT_PHONE' || data.otpTarget === 'NEW_PHONE'
      ? data.otpTarget
      : mappedOtpType.otpTarget;
  const maskedPhone = typeof data.maskedPhone === 'string' ? data.maskedPhone : undefined;
  const message = typeof data.message === 'string' ? data.message : undefined;

  if (!code && !header) return undefined;

  return { code, otpTarget, header, maskedPhone, message };
};
